var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$parent.isActive)?_c('ActivityList',{attrs:{"filter":"deck","object-id":_vm.board.id,"object-type":"deck","type":"deck"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }